import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Axios from 'axios'

import {
    SIGNUP_URL
} from '../../constants/urls'

import {
    makeStyles,
    Container,
    Paper,
    FormControl,
    TextField,
    Typography,
    Button
} from '@material-ui/core'

const useStyle = makeStyles(theme => ({
    root: {
        margin: theme.spacing(6, 2),
        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(4, 1)
        }
    },
    paper: {
        padding: theme.spacing(6, 12),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(4, 2)
        }
    },
    input: {
        margin: theme.spacing(2, 0)
    }
}))

const Signup = props => {
    const classes = useStyle()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [email, setupEmail] = useState('')
    const history = useHistory()

    const signupHandler = () => {
        if (username === '' || password === '') {
            return
        }

        Axios({
            method: 'POST',
            url: SIGNUP_URL,
            data: {
                username: username,
                password: password,
                email: email
            }
        }).then(res => {
            localStorage.setItem('cphf-token', res.data.token)
            localStorage.setItem('cphf-type', res.data.type)
            localStorage.setItem('cphf-username', res.data.username)
            history.push('/')
        }).catch(err => {
            console.log(err)
        })
    }


    return (
        <div className={classes.root}>

            <Container>
                <Paper variant="outlined" className={classes.paper}>
                    <FormControl fullWidth className={classes.input}>
                        <TextField
                            label="Username"
                            variant="outlined"
                            value={username}
                            onChange={(event) => { setUsername(event.target.value) }}
                        />
                    </FormControl>
                    <FormControl fullWidth className={classes.input}>
                        <TextField
                            label="Username"
                            variant="outlined"
                            value={email}
                            onChange={(event) => { setupEmail(event.target.value) }}
                        />
                    </FormControl>
                    <FormControl fullWidth className={classes.input}>
                        <TextField
                            label="password"
                            variant="outlined"
                            value={password}
                            onChange={(event) => { setPassword(event.target.value) }}
                        />
                    </FormControl>

                    <Typography>
                        Already have a account? <Link to="/login">Login</Link>
                    </Typography>

                    <center>
                        <Button
                            size="large"
                            variant="contained"
                            color="primary"
                            onClick={signupHandler}
                        >
                            Signup
                        </Button>
                    </center>
                </Paper>
            </Container>
        </div>
    )
}

export default Signup